// @flow

import bemify from 'bemify-js';
import React, { useEffect } from 'react';

import AccountDropdown from 'app/viewport/components/AccountDropdown';
import AccountDropdownToggler from 'app/common/components/AccountDropdownToggler';
import DropdownStateful from 'app/common/components/DropdownStateful';
import createRenderCallback from 'app/common/components/createRenderCallback';
import 'app/viewport/components/AccountMenu.scss';

import type { AccountDropdownProps } from 'app/viewport/components/AccountDropdown';

const bem = bemify('account-menu');

type AccountMenuProps = {
  ...AccountDropdownProps,
  accountId: number,
  className: string,
  hasTeam: boolean,
  onAccountMenuDropdownOpen: () => void,
  onMount: () => void,
  onUpgradeClick: () => void,
  userName: string,
};

const AccountMenu = (props: AccountMenuProps) => {
  const {
    accountId,
    className,
    hasTeam,
    onAccountMenuDropdownOpen,
    onMount,
    planName,
    userName,
  } = props;

  const plan = planName ? `${planName} Plan` : '';

  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <DropdownStateful
      className={bem(className)}
      onOpen={onAccountMenuDropdownOpen}
      renderMenu={createRenderCallback(AccountDropdown, props)}
      renderToggle={createRenderCallback(AccountDropdownToggler, {
        accountId,
        className: bem('__toggler'),
        title: userName,
        meta: hasTeam ? null : plan,
        hideArrow: true,
        hideDetails: true,
      })}
    />
  );
};

export default AccountMenu;
